module.exports = __webpack_public_path__ + "static/WEDDING E&M-512-b359c6392f44d28ebcdd25e81afa78f4.jpg";